export default __webpack_public_path__ + "static/media/evening.c56ef6bb.svg";